// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getPickupAnalyticsApi } from "../../Service/Api/PickupAnalyticsApi"
import { getPickupAnalyticsList,getErrors } from "../Reducer/PickupAnalyticsReducer"
 
 

 

// Watchers
function* pickupAnalyticsSaga() {
	yield takeEvery("pickupAnalytics/getPickupAnalytics", getPickupsAnalytics)
}

// Sagas
function* getPickupsAnalytics(action) {
	// console.log(action)
	try {
		const getPickupAnalytics = yield call(getPickupAnalyticsApi, action.payload)
		// console.log(getOrdersAnalytics.status);
		if (getPickupAnalytics.request.status === 200) {
			yield put(getPickupAnalyticsList(getPickupAnalytics))
			// console.log(getOrdersAnalytics.status);
		} else {
			yield put(getErrors(getPickupAnalytics))
		}
	} catch (error) {

		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(pickupAnalyticsSaga)])
}
